import {
  Document,
  DocumentVersion,
  DocumentVersionApprover,
} from "src/stores/models/document";
import type { LocalData } from "./AuthorContent";

export const enableSaveButton = (
  selectedDoc: Document,
  formData: LocalData,
  selectedDocVersion: DocumentVersion,
  dependentDocs: [string, string][],
  agreement: boolean,
  approvers: DocumentVersionApprover[],
  isSaving: boolean,
  shouldShowMetadataSection: boolean
) => {
  const areApproversValid =
    formData.selectedUsers.every((u) => u !== null) &&
    formData.selectedUsers.length === 2 &&
    formData.selectedUsers[0]?.id !== formData.selectedUsers[1]?.id;
  const isSummaryValid = !!formData.revisionSummary;

  const isDocMetadataValid = shouldShowMetadataSection
    ? Object.entries(formData.documentMetadata).every(([_, value]) => {
        // Validate that required fields have a non-empty value
        return value !== "" && value !== null && value !== undefined;
      })
    : true;
  const assigneesChanged = formData.selectedUsers.some((u) =>
    approvers.every((a) => a.user.id !== u?.id)
  );
  const summaryChanged =
    formData.revisionSummary !== selectedDocVersion.revisionSummary;

  const savedDocumentMetadata = {
    title: selectedDoc.title,
    regulatoryType: selectedDoc.regulatoryType,
    regulatoryFunctionalGroup: selectedDoc.regulatoryFunctionalGroup,
  };

  const documentMetadataChanged =
    shouldShowMetadataSection &&
    JSON.stringify(formData.documentMetadata) !==
      JSON.stringify(savedDocumentMetadata);

  const approvalConfigChanged =
    assigneesChanged || summaryChanged || documentMetadataChanged;

  const shouldCheckForDependencies =
    dependentDocs.length > 0 ? agreement : true;

  return (
    approvalConfigChanged &&
    areApproversValid &&
    isSummaryValid &&
    isDocMetadataValid &&
    !isSaving &&
    shouldCheckForDependencies
  );
};
